// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { getDealerEnginePreviewSuccess, getDealerEnginePreviewError, ActionGetDealerEnginePreview } from './actions';
import { UIListingLocation } from './types';

import { createAPINetworkInstance } from '../../../../../common/api';
import { parseAPIListingPreview } from 'features/Dealers/Listings/GMBPreview/state/utils';

function* getDealerEnginePreview(action: ActionGetDealerEnginePreview) {
    try {
        const { engineId, listingId } = action
        const { data } = yield call(createAPINetworkInstance().get, `listing/${listingId}/engine/${engineId}/preview`);
        const preview: UIListingLocation = parseAPIListingPreview({ ...data });
        yield put(getDealerEnginePreviewSuccess(preview));
    } catch (err) {
        yield put(getDealerEnginePreviewError(err));
    }
}

export default function* dealerLMConfigSagas() {
    yield takeLatest(ACTIONS.GET_DEALER_ENGINE_PREVIEW_API_REQUEST, getDealerEnginePreview);
}